/**
 * Module:  Account
 * @description	JS interface for accounts
 */

/**
 * Constructor
 * @param {object} options Optional properties to override defaults
 */
function Account(options) {
	this.init();
}

/**
 * Setup
 */
Account.prototype.init = () => {
	if (Account) {
		let inputs = document.querySelector('.registration-roles');
		if (inputs) {
			inputs = inputs.querySelectorAll('input');

			[...inputs].forEach((input) => {
				input.addEventListener('change', (e) => {
					if (e.target.value === 'dealer') {
						document.querySelector('.registration-customer-id').style.display =
							'block';
					} else {
						document.querySelector('.registration-customer-id input').value =
							'';
						document.querySelector('.registration-customer-id').style.display =
							'none';
					}
				});
			});
		}
	}

	const addressFields = document.querySelector('.woocommerce-address-fields');
	if(addressFields) {
		const modifyCheckoutFields = () => {
			const fieldLabels = document.querySelectorAll('.form-row abbr.required');
			if(fieldLabels.length) {
				fieldLabels.forEach(field => {
					const fNode = field;
					fNode.textContent = '';
				});
			}
		};

		setTimeout(() => {
			modifyCheckoutFields();
		},100);

		window.jQuery(document.body).on('country_to_state_changed', () => {
			setTimeout(() => {
				modifyCheckoutFields();
			}, 100);
		});
	}
};

/**
 * Public API
 */
module.exports = {
	init(opts) {
		return new Account(opts);
	},
};
